import { render } from "./DeviceRow.vue?vue&type=template&id=64c43814&scoped=true&ts=true&lang=pug"
import script from "./DeviceRow.vue?vue&type=script&lang=ts"
export * from "./DeviceRow.vue?vue&type=script&lang=ts"

import "./DeviceRow.vue?vue&type=style&index=0&id=64c43814&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c43814"]])

export default __exports__